<!--销售 收款 -->
<template>
    <div v-loading="loading">
        <el-form :rules="rules" :model="submitData" label-width="120px" ref="submitData">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="需收款总金额">
                            <el-input v-model="orderData.SurplusMoney" disabled="disabled"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="待收款金额">
                            <el-input v-model="waitPay" disabled="disabled"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="已收款金额">
                            <el-input v-model="orderData.Paid" disabled="disabled"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="结算方式" prop="PayType">
                            <el-select v-model="submitData.PayType" placeholder="请选择" style="width: 100%" :disabled="ReadOnly">
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="申请收款金额" prop="CollectionAmount">
                            <el-input type="number" step="0.01" v-model="submitData.CollectionAmount" :min="0" :disabled="ReadOnly"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div class="grid-content bg-purple">
                        <el-form-item label="备注">
                            <el-input v-model="submitData.Remark" :disabled="ReadOnly"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()" v-if="isCanApply && !ReadOnly">提交申请</el-button>
        </div>
        <div>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="form-uploadImg">
                        <div>上传流水单据</div>
                        <el-upload
                            :action="uploadImgUrl"
                            :data="uploadImgData"
                            :headers="headerObj"
                            :file-list="orderImages"
                            list-type="picture-card"
                            accept="image/jpeg, image/png"
                            :on-preview="onUploadPreview"
                            :on-remove="onUploadRemove"
                            :before-remove="beforeRemove"
                            :on-success="onUploadSuccess"
                            :disabled="!(isCanApply && !ReadOnly)"
                            :class="{ hideUpload: !(isCanApply && !ReadOnly) }"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogImageVisible" append-to-body>
                            <img width="100%" :src="dialogImageUrl" alt="" />
                        </el-dialog>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div>
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border=""
                show-summary
                :summary-method="getSummaries_apply"
                style="width: 100%; margin-bottom: 0px; margin-top: 15px"
            >
                <el-table-column show-overflow-tooltip width="190px" prop="PayCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="120px" prop="SumPayable" label="订单总金额"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip width="100px" prop="AlreadyPaid" label="已收款金额"></el-table-column> -->
                <el-table-column show-overflow-tooltip width="150px" prop="ApplyPay" label="申请收款金额"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" prop="NowPay" label="实收金额"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip width="120px" prop="Unpaid" label="剩余申请金额"></el-table-column> -->
                <el-table-column show-overflow-tooltip width="80px" prop="PayTypeName" label="结算方式"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="ApplyName" label="申请人"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="申请时间"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="ops-ctn" v-if="!scope.row.IsConfirm && !scope.row.IsCancel && !ReadOnly">
                            <el-button title="撤销" size="mini" type="text" @click="cancelPayRecord(scope.row.Id)">撤销</el-button>
                        </div>
                        <div class="ops-ctn" v-else-if="!scope.row.IsConfirm && scope.row.IsCancel">已撤销</div>
                        <div class="ops-ctn" v-else-if="scope.row.IsConfirm && !scope.row.IsCancel">已确认</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        orderData: { type: Object },
        type: { type: Number } //操作类型
    },
    components: {},
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            userMsg: userMsg,
            ReadOnly: true,
            orderImages: [],
            uploadImgData: {},
            uploadImgUrl: this.$util.BASE_URL + '/EntpSaleOrder/AddOrderImage',
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            dialogImageUrl: '',
            uploadImgFile: null,
            dialogImageVisible: false,
            isCanApply: true,
            payDataCount: 0,
            waitPay: 0,
            payWayList: [],
            submitData: {
                PayType: '',
                CollectionAmount: 0,
                EntpCusOId: '',
                ISPay: false,
                Remark: ''
            },
            rules: {
                PayType: [{ required: true, message: '该项必填', trigger: 'change' }],
                CollectionAmount: [{ required: true, message: '该项必填', trigger: 'change' }]
            },
            tableData: [],
            cancelPayRecordData: {
                Id: '',
                OperateType: 0,
                OperatorId: userMsg.EmployeeId
            },
            PayType: "",
        };
    },
    mounted() {
        //只有是申请收款时才能做操作
        if (this.type == '5') {
            this.ReadOnly = false;
        }
        this.uploadImgData = {
            OrderId: this.orderData.EntpCusOId,
            OrderType: 0
        };

        this.getOrderDetails();
        this.getPay();
    },
    beforeDestroy() {
        //注销粘贴事件
        document.removeEventListener('paste', this.handlePaste, false);
    },
    methods: {
        cancel() {
            //注销粘贴事件
            document.removeEventListener('paste', this.handlePaste, false);
            this.$emit('closeReceipt');
        },
        submitForm() {
            if (this.submitData.CollectionAmount <= 0) {
                this.$util.warningMsg('申请收款金额必须大于0');
                return;
            }
            if (parseFloat(this.submitData.CollectionAmount) > parseFloat(this.waitPay)) {
                this.$confirm('收款金额已超过待收款金额，是否继续申请收款？', '提示', {
                    confirmButtonText: '确定继续申请',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.$refs['submitData'].validate(valid => {
                            if (valid) {
                                this.loading = true;
                                this.$util
                                    .axiosPost({
                                        url: '/api/EntpSaleOrder/ApplyCollection',
                                        data: this.submitData
                                    })
                                    .then(res => {
                                        this.$util.successMsg('申请收款成功');
                                        this.getOrderDetails();
                                    })
                                    .catch(() => {
                                        this.loading = false;
                                    });
                            } else {
                                return false;
                            }
                        });
                    })
                    .catch(() => {});
            } else
                this.$refs['submitData'].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/ApplyCollection',
                                data: this.submitData
                            })
                            .then(res => {
                                this.$util.successMsg('申请收款成功');
                                this.getOrderDetails();
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    } else {
                        return false;
                    }
                });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
                this.submitData.PayType = this.PayType;
            });
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetPaymentAndReceiptRecordsByOId',
                    data: { orderId: this.orderData.EntpCusOId },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.payDataCount = res.count;
                    this.tableData = data;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        cancelPayRecord(id) {
            if (id) {
                this.$confirm('是否撤销该条收款申请？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.cancelPayRecordData.id = id;
                        this.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/OperatePaymentAndReceiptRecord',
                                data: this.cancelPayRecordData
                            })
                            .then(res => {
                                this.$util.successMsg('撤销成功');
                                this.getOrderDetails();
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效付款记录');
            }
        },
        getOrderDetails() {
            this.loading = true; //在getTableData()关闭loading
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetOrderInfoById',
                    data: {
                        EntpCusOId: this.orderData.EntpCusOId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.getTableData();

                    let data = res.data;

                    this.orderData.SurplusMoney = data.SurplusMoney;
                    this.orderData.Paid = data.Paid;

                    this.submitData.Remark = '';
                    this.submitData.EntpCusOId = data.EntpCusOId;
                    // this.submitData.PayType = data.PayType;
                    this.PayType= data.PayType;

                    let need = data.SurplusMoney - data.Paid;

                    this.waitPay = need <= 0 ? 0 : need.toFixed(2);
                    // this.submitData.CollectionAmount = need <= 0 ? 0 : need.toFixed(2);
                    //可申请金额应该为
                    this.submitData.CollectionAmount = data.CanApplyMoney >= 0 ? data.CanApplyMoney.toFixed(2) : data.SurplusMoney;
                    this.isCanApply = !data.IsPay;

                    this.orderImages = data.OrderImages;
                    for (let j = 0; j < this.orderImages.length; j++) {
                        this.orderImages[j].name = this.orderImages[j].Id;
                        this.orderImages[j].url = this.$util.QN_URL_BASE + this.orderImages[j].ImgUrl;
                    }
                    if (!this.ReadOnly && this.isCanApply) {
                        this.$nextTick(() => {
                            //注册粘贴事件
                            document.addEventListener('paste', this.handlePaste, false);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 监听粘贴操作
        handlePaste(event) {
            let that = this;
            if (that.ReadOnly) {
                return;
            }
            const items = (event.clipboardData || window.clipboardData).items;
            let file = null;
            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持本地');
                return;
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    file = items[i].getAsFile();
                    break;
                }
            }
            if (!file) {
                // this.$message.error("粘贴内容非图片");
                return;
            }

            if (!this.$util.uploadCheck(file)) {
                return;
            }

            let loading = this.$loading({
                lock: true,
                target: document.querySelector('.business-content'),
                text: '上传中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            let fd = new window.FormData();
            fd.append('file', file);
            fd.append('OrderId', that.uploadImgData.OrderId);
            fd.append('OrderType', that.uploadImgData.OrderType);
            let xhr = new XMLHttpRequest();
            xhr.open('POST', that.uploadImgUrl, true);
            xhr.setRequestHeader('access-key', that.userMsg.Token);
            xhr.setRequestHeader('reqApp', 'yqgPC');
            xhr.onload = () => {
                if (xhr.status === 200) {
                    let result = JSON.parse(xhr.responseText);
                    const reader = new FileReader();
                    reader.onload = event => {
                        that.orderImages.push({
                            Id: result.data,
                            url: event.target.result
                        });
                    };
                    reader.readAsDataURL(file);
                    loading.close();
                }
            };
            xhr.onerror = () => {
                this.$util.errorMsg('上传失败');
                loading.close();
            };
            xhr.send(fd);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`是否确定删除该流水单据？`);
        },
        onUploadRemove(file) {
            let id = file.Id;
            if (!id) {
                //刚新增的图片对象没有Id对象
                id = file.uid;
            }
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/DelOrderImage?imgId=' + id
                })
                .then(res => {
                    let i = this.orderImages.findIndex(item => {
                        if (item.Id == id) {
                            return true;
                        }
                    });
                    if (i > -1) {
                        this.orderImages.splice(i, 1);
                    }
                })
                .catch(() => {
                    return false;
                });
        },
        onUploadPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogImageVisible = true;
        },
        onUploadSuccess(response, file, fileList) {
            let that = this;
            if (response.errcode == 0) {
                fileList.forEach(e => {
                    if (e.uid == file.uid) {
                        e.uid = response.data; //替换成数据库的id，为了删除功能

                        that.orderImages.push({
                            Id: response.data,
                            url: e.url
                        });
                    }
                });
            } else {
                this.$util.warningMsg(response.data);
            }
        },
        getSummaries_apply(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 2) {
                    let totalAmount = 0;
                    if (data.length > 0) totalAmount = Number(data[0].SumPayable);
                    let applyTotal = data.reduce((prev, curr) => {
                        if (curr.IsCancel) return prev;
                        else return prev + Number(curr.ApplyPay);
                    }, 0);
                    sums[index] = '剩余可申请：' + (totalAmount > applyTotal ? totalAmount - applyTotal : 0).toFixed(2);
                    return;
                } else if (index === 3) {
                    let sum = data.reduce((prev, curr) => {
                        if (curr.IsCancel || !curr.IsConfirm) return prev;
                        else return prev + Number(curr.NowPay);
                    }, 0);
                    sums[index] = '已收：' + sum.toFixed(2);
                    return;
                } else {
                    sums[index] = '';
                    return;
                }
            });

            return sums;
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}
.btn-ctn {
    text-align: right;
}
.el-row {
    margin-bottom: 0px;
    &:last-child {
        margin-bottom: 0;
    }
}
</style>
